import * as React from 'react';

import {SaveButton} from 'shells/button/save-button/save-button';
import {Body} from 'shells/typography/body';

import styles from './add-footer.module.css';

type Props = {
    firstContactName: string;
    numSelectedContacts: number;
    unlocksRemaining: number;
    onAddContacts: () => void;
    isSaving: boolean;
};

export function AddFooter(props: Props) {
    const othersText = props.numSelectedContacts > 2 ? 'others' : 'other';
    const otherContactsText =
        props.numSelectedContacts > 1 ? ` & ${props.numSelectedContacts - 1} ${othersText}` : '';
    const addText = `Add ${props.firstContactName}${otherContactsText}`;

    const isSaveDisabled = props.numSelectedContacts > props.unlocksRemaining;

    return (
        <div className={styles.container}>
            <div className='mb-16'>
                <div className='mb-4'>
                    <Body size='normal' isBold={true}>
                        {addText} to Nutshell
                    </Body>
                </div>
                <Body size='small'>
                    This will use {props.numSelectedContacts} of your{' '}
                    {props.unlocksRemaining.toLocaleString()} remaining credits.
                </Body>
            </div>
            <SaveButton
                disabled={isSaveDisabled}
                // @ts-expect-error
                onClick={props.onAddContacts}
                isSaving={props.isSaving}
                isFullWidth={true}
                justifyCenter={true}
                buttonText={addText}
                savingText='Adding…'
            />
        </div>
    );
}
